export const appData = {
  isResizing: false
}
export const pageInitState = { home: false, web: false, email: false, graphic: false, photo: false, retouch: false,
  coming: false, error: false };

export const errorData = {
  404: {
    title: "Page Not Found",
    message: "We're sorry, we can't seem to find the page you're looking\u00A0for. It\u00A0might have been moved, deleted, or\u00A0perhaps the URL was\u00A0mistyped."
  }
};
